import classNames from 'classnames'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsComputingDone, selectIsComputingDoneOrFailed } from '../../../store/itinerary/itinerary.selectors'
import { invertSteps } from '../../../store/itinerary/itinerarySlice'
import invertedArrows from '../../genericComponents/assets/inverted-arrows.svg?raw'
import useEventCallback from '../../utils/useEventCallback'
import s from './InvertStepsButton.less'

const InvertStepsButton = ({ stepId }) => {
  const dispatch = useDispatch()
  const onClick = useEventCallback(() => dispatch(invertSteps(stepId)), [stepId])
  const isComputingDone = useSelector(selectIsComputingDoneOrFailed)

  return (
    <div
      className={classNames('icon', s.root, !isComputingDone && 'disabled')}
      onClick={isComputingDone ? onClick : undefined}
      dangerouslySetInnerHTML={{ __html: invertedArrows }}
    ></div>
  )
}

export default InvertStepsButton
